export default [
  { label: "Serviços", value: "product_category_display_name", className: "w-24" },
  { label: "Nome", value: "product_display_name", className: "w-36" },
  { label: "Métrica", value: "unit_for_quantity", className: "w-12" },
  { label: "Preço a vista", value: "value", className: "w-96" },
  { label: "Última atualização por", value: "last_update_by", className: "w-36" },
];
